/**
 * The arrangement flow's loading spinner — a sage ring on an oat track.
 * Centralised so the signing screens share one definition.
 */
export default function ArrangementSpinner() {
  return (
    <div className="mx-auto h-12 w-12 animate-spin rounded-full border-4 border-oat border-t-sage" />
  );
}
